import * as Constants from "./constants";

const config = {
  API_URL:  import.meta.env.DEV ? '/api' : 'https://api.admin.upclaim.eu',
  SEARCH_API_URL: import.meta.env.TYPESENSE_SERVER_URL || 'search.upclaim.eu', // Set value to `/typesense-server` to call local instance
  Constants,
}

export default Object.freeze(config)
